import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import DictionariesRateUpdateModel from "../../../viewModels/Dictionaries/DictionariesRateUpdateModel";
import LocationModel from "../../../viewModels/Location/LocationModel";
import { DigitalLogistCarrierBasicInfoModel } from "../../../viewModels/Carriers/DigitalLogistCarrierModel";

const initialState: {
  loading: boolean;
  loadingData: boolean;
  id: number;

  routes: Array<DictionariesRateUpdateModel>;
  locations: Array<LocationModel>;
  carriers: Array<DigitalLogistCarrierBasicInfoModel>;

  total: number;
  pageSize: number;
  page: number;
} = {
  loading: true,
  loadingData: true,

  id: undefined!,

  routes: undefined!,
  carriers: undefined!,
  locations: undefined!,

  total: undefined!,
  pageSize: 10,
  page: 1,
};

const dictionariesRateUpdateRoutesSlice = createSlice({
  name: "dictionariesRateUpdateRoutes",
  initialState,
  reducers: {
    loadRateUpdateRoutes(state, action: PayloadAction<number>) {
      state.loadingData = true;
      state.page = 1;
      state.id = action.payload;
    },
    loadRateUpdateRoutesSuccess(
      state,
      action: PayloadAction<{
        routes: Array<DictionariesRateUpdateModel>;
        total: number;
        locations: Array<LocationModel>;
        carriers: Array<DigitalLogistCarrierBasicInfoModel>;
      }>,
    ) {
      const { routes, total, carriers, locations } = action.payload;
      state.loading = false;
      state.loadingData = false;
      state.routes = routes;
      state.total = total;
      state.locations = locations;
      state.carriers = carriers;
    },
    loadRateUpdateRoutesError(state) {
      state.loading = false;
      state.loadingData = false;
    },
    changeTable(state, action: PayloadAction<{ page: number; pageSize: number }>) {
      state.page = action.payload.page;
      state.pageSize = action.payload.pageSize;
      state.loadingData = true;
    },
  },
});

export default dictionariesRateUpdateRoutesSlice;
